(function () {
  const SECTION_SELECTOR = '[data-made-with-ugc]';
  const INITIALIZATION_RETRIES = 40;
  const INITIALIZATION_INTERVAL_MS = 100;

  /**
   * @param {HTMLElement} sectionElement
   * @param {HTMLElement} slider
   * @param {boolean} isMobile
   */
  const initializeSwiper = (sectionElement, slider, isMobile) => {
    const SwiperCtor = /** @type {any} */(window).Swiper;
    if (!SwiperCtor) return null;

    if (isMobile) {
      // Mobile-only slider (3 cards): simple loop, no desktop breakpoints.
      // slidesPerView: 'auto' keeps each slide's width from CSS, not the container.
      return new SwiperCtor(slider, {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        resistanceRatio: 0,
        spaceBetween: 16,
        speed: 500,
        on: {
          /** @param {{ slideToLoop: (index: number, speed: number, runCallbacks: boolean) => void }} swiper */
          init(swiper) { swiper.slideToLoop(0, 0, false); },
          // recompute offsets after the active slide's CSS width transition
          slideChangeTransitionEnd(swiper) { swiper.update(); },
        },
      });
    }

    // Full swiper (4+ cards): desktop navigation + breakpoints.
    const nextButton = sectionElement.querySelector('[data-made-with-ugc-next]');
    const prevButton = sectionElement.querySelector('[data-made-with-ugc-prev]');
    if (!nextButton || !prevButton) return null;

    return new SwiperCtor(slider, {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      resistanceRatio: 0,
      spaceBetween: 16,
      speed: 500,
      loopAdditionalSlides: 0,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        /** @param {{ slideToLoop: (index: number, speed: number, runCallbacks: boolean) => void }} swiper */
        init(swiper) { swiper.slideToLoop(0, 0, false); },
        slideChangeTransitionEnd(swiper) { swiper.update(); },
      },
      breakpoints: {
        640:  { spaceBetween: 18 },
        769:  { spaceBetween: 40 },
        1440: { spaceBetween: 40 },
      },
    });
  };

  /** @param {HTMLElement} sectionElement */
  const initializeSection = (sectionElement) => {
    const SwiperCtor = /** @type {any} */(window).Swiper;
    if (!SwiperCtor) return false;

    const sliders = /** @type {NodeListOf<HTMLElement>} */(
      sectionElement.querySelectorAll('[data-made-with-ugc-swiper]')
    );
    if (!sliders.length) return false;

    const instances = /** @type {any[]} */([]);

    sliders.forEach((slider) => {
      const isMobile = slider.hasAttribute('data-made-with-ugc-mobile');
      const instance = initializeSwiper(sectionElement, slider, isMobile);
      if (instance) instances.push(instance);
    });

    if (!instances.length) return false;

    sectionElement.addEventListener('shopify:section:unload', () => {
      instances.forEach((inst) => inst.destroy(true, true));
    }, { once: true });

    return true;
  };

  /** @param {HTMLElement} sectionElement */
  const setupSection = (sectionElement) => {
    if (initializeSection(sectionElement)) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (initializeSection(sectionElement) || attempts >= INITIALIZATION_RETRIES) {
        window.clearInterval(timer);
      }
    }, INITIALIZATION_INTERVAL_MS);
  };

  const initializeAllSections = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((el) => {
      const section = /** @type {HTMLElement} */(el);
      if (!section.dataset.mwugcReady) {
        section.dataset.mwugcReady = 'true';
        setupSection(section);
      }
    });
  };

  /** @param {Event} event */
  const handleSectionLoad = (event) => {
    const target = /** @type {HTMLElement} */(event.target);
    const section = target.matches(SECTION_SELECTOR)
      ? target
      : target.querySelector(SECTION_SELECTOR);
    if (section && !(/** @type {HTMLElement} */(section)).dataset.mwugcReady) {
      /** @type {HTMLElement} */(section).dataset.mwugcReady = 'true';
      setupSection(/** @type {HTMLElement} */(section));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllSections, { once: true });
  } else {
    initializeAllSections();
  }

  document.addEventListener('shopify:section:load', handleSectionLoad);
})();
